module.exports = __webpack_public_path__ + "static/img/b1-3-1.e5e221b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/b1-3-1.png
// module id = IgZk
// module chunks = 1